  // Ofertas ativas: apenas 2 (edição solicitada em 2026)
  (function() {
    var btns = document.querySelectorAll('.variacao-opcoes .variacao-btn');
    if (btns.length < 3) return;

    var b1 = btns[0];
    b1.setAttribute('data-link', '/cart/47083618566198:1');
    b1.setAttribute('data-preco', '124900');
    b1.setAttribute('data-preco-de', '230000');
    var b1badge = b1.querySelector('.badge-topo');
    if (b1badge) { b1badge.textContent = 'Más Vendido'; b1badge.className = 'badge-topo green'; }
    var b1img = b1.querySelector('.var-img');
    if (b1img) { b1img.src = 'https://pub-34e8d362c4cb41e7a63851f01f9f156c.r2.dev/bundle-2.png'; b1img.alt = 'Compra 1 y Lleva 2'; }
    var b1nome = b1.querySelector('.var-nome');
    if (b1nome) b1nome.textContent = 'Compra 1 y Lleva 2';
    var b1econ = b1.querySelector('.var-econ');
    if (b1econ) b1econ.textContent = 'Ahorras 46%';
    var b1precoDe = b1.querySelector('.var-preco-de');
    if (b1precoDe) b1precoDe.textContent = '$230.000';
    var b1preco = b1.querySelector('.var-preco');
    if (b1preco) b1preco.textContent = '$124.900';

    var b2 = btns[1];
    b2.setAttribute('data-link', '/cart/47083618598966:1');
    b2.setAttribute('data-preco', '249900');
    b2.setAttribute('data-preco-de', '460000');
    var b2badge = b2.querySelector('.badge-topo');
    if (b2badge) { b2badge.textContent = 'Mejor Ahorro'; b2badge.className = 'badge-topo purple'; }
    var b2img = b2.querySelector('.var-img');
    if (b2img) { b2img.src = 'https://pub-34e8d362c4cb41e7a63851f01f9f156c.r2.dev/bundle-3.png'; b2img.alt = 'Compra 2 y Lleva 4'; }
    var b2nome = b2.querySelector('.var-nome');
    if (b2nome) b2nome.textContent = 'Compra 2 y Lleva 4';
    var b2econ = b2.querySelector('.var-econ');
    if (b2econ) b2econ.textContent = 'Ahorras 46%';
    var b2precoDe = b2.querySelector('.var-preco-de');
    if (b2precoDe) b2precoDe.textContent = '$460.000';
    var b2preco = b2.querySelector('.var-preco');
    if (b2preco) b2preco.textContent = '$249.900';

    if (btns[2]) btns[2].remove();

    var idInput = document.getElementById('cod-variant-id');
    if (idInput) idInput.value = '47083618566198';
  })();

  // Year
  document.getElementById('ano').textContent = new Date().getFullYear();

  // ------------------------------------------------------------
  // Galeria carrossel
  // ------------------------------------------------------------
  var thumbs = document.querySelectorAll('#thumbs img');
  var imgPrincipal = document.getElementById('img-principal');
  var lightboxImg = document.getElementById('lightbox-img');
  var galeriaMain = document.getElementById('galeria-main');
  var galeriaTrack = document.getElementById('galeria-track');
  var slides = galeriaTrack ? galeriaTrack.querySelectorAll('.galeria-slide') : [];
  var slideImgs = galeriaTrack ? galeriaTrack.querySelectorAll('.galeria-slide img') : [];
  var TOTAL = slides.length;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current = 0;
  var dragging = false;
  var dragStartX = 0;
  var dragDX = 0;
  var dragLocked = false;
  var SWIPE_THRESHOLD = 50;
  var INTERVAL_MS = 10000;
  var INITIAL_DELAY_MS = 3000;
  var autoplayTimer = null;
  var inViewport = false;
  var initialized = false;

  function setTrackTransform(offsetPx) {
    if (!galeriaTrack) return;
    var w = galeriaMain.clientWidth || 1;
    var base = -current * w;
    galeriaTrack.style.transform = 'translateX(' + (base + (offsetPx || 0)) + 'px)';
  }

  function updateThumbActive(i) {
    thumbs.forEach(function(t) { t.classList.remove('ativo'); });
    if (thumbs[i]) thumbs[i].classList.add('ativo');
  }

  function updateLightboxSrc() {
    if (lightboxImg && slideImgs[current]) {
      lightboxImg.src = slideImgs[current].src;
    }
  }

  function goTo(index, animate) {
    if (!TOTAL) return;
    var next = index;
    if (next < 0) next = 0;
    if (next > TOTAL - 1) next = TOTAL - 1;
    current = next;
    if (galeriaTrack) {
      if (animate === false || reduceMotion) {
        galeriaTrack.classList.add('no-anim');
      } else {
        galeriaTrack.classList.remove('no-anim');
      }
      setTrackTransform(0);
      if (animate === false || reduceMotion) {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { galeriaTrack.classList.remove('no-anim'); });
        });
      }
    }
    updateThumbActive(current);
    updateLightboxSrc();
  }

  function next() { if (current < TOTAL - 1) goTo(current + 1, true); }
  function prev() { if (current > 0) goTo(current - 1, true); }

  function clearAutoplay() {
    if (autoplayTimer) { clearTimeout(autoplayTimer); autoplayTimer = null; }
  }
  function shouldAutoplay() {
    if (reduceMotion) return false;
    if (document.hidden) return false;
    if (!inViewport) return false;
    var lb = document.getElementById('lightbox');
    if (lb && lb.classList.contains('aberto')) return false;
    return true;
  }
  function scheduleAutoplay(delay) {
    clearAutoplay();
    if (!shouldAutoplay()) return;
    autoplayTimer = setTimeout(function() {
      if (shouldAutoplay()) {
        if (current < TOTAL - 1) {
          next();
          scheduleAutoplay(INTERVAL_MS);
        } else {
          autoplayTimer = null;
        }
      } else {
        autoplayTimer = null;
      }
    }, delay);
  }
  function resetAutoplay() {
    scheduleAutoplay(INTERVAL_MS);
  }

  thumbs.forEach(function(t, i) {
    t.addEventListener('click', function() {
      goTo(i, true);
      resetAutoplay();
    });
  });

  function abrirLightbox() {
    var lb = document.getElementById('lightbox');
    if (!lb) return;
    updateLightboxSrc();
    lb.classList.add('aberto');
    document.body.style.overflow = 'hidden';
  }
  function fecharLightbox(e) {
    var lb = document.getElementById('lightbox');
    if (!lb) return;
    if (!e || e.target.id === 'lightbox' || e.target.classList.contains('lightbox-fechar')) {
      lb.classList.remove('aberto');
      document.body.style.overflow = '';
    }
  }
  window.abrirLightbox = abrirLightbox;
  window.fecharLightbox = fecharLightbox;

  // ---- Lightbox: fechar, navegar, arrastar, teclado ----
  var lb = document.getElementById('lightbox');
  var lbCounter = document.getElementById('lb-counter');

  function lbClose() {
    if (!lb) return;
    lb.classList.remove('aberto');
    document.body.style.overflow = '';
  }
  function lbUpdateCounter() {
    if (lbCounter && TOTAL) lbCounter.textContent = (current + 1) + ' / ' + TOTAL;
  }
  function lbGoTo(i) {
    goTo(i, true);
    lbUpdateCounter();
  }

  // Sobrescreve abrirLightbox para atualizar contador ao abrir
  window.abrirLightbox = function() {
    if (!lb) return;
    updateLightboxSrc();
    lbUpdateCounter();
    lb.classList.add('aberto');
    document.body.style.overflow = 'hidden';
  };

  if (lb) {
    // Fechar no fundo ou no X
    lb.addEventListener('click', function(e) {
      if (e.target === lb || e.target.classList.contains('lightbox-fechar')) lbClose();
    });

    // Setas
    var lbPrev = lb.querySelector('.lb-prev');
    var lbNext = lb.querySelector('.lb-next');
    if (lbPrev) lbPrev.addEventListener('click', function(e) { e.stopPropagation(); lbGoTo(current - 1); });
    if (lbNext) lbNext.addEventListener('click', function(e) { e.stopPropagation(); lbGoTo(current + 1); });

    // Drag / swipe na imagem expandida
    var lbImg = document.getElementById('lightbox-img');
    var lbDragStartX = 0, lbDragging = false;
    if (lbImg) {
      lbImg.addEventListener('mousedown', function(e) { lbDragging = true; lbDragStartX = e.clientX; e.preventDefault(); });
      lb.addEventListener('mousemove', function(e) { /* passivo */ });
      lb.addEventListener('mouseup', function(e) {
        if (!lbDragging) return;
        lbDragging = false;
        var dx = e.clientX - lbDragStartX;
        if (Math.abs(dx) > 40) { dx < 0 ? lbGoTo(current + 1) : lbGoTo(current - 1); }
      });
      lbImg.addEventListener('touchstart', function(e) { lbDragStartX = e.touches[0].clientX; }, { passive: true });
      lbImg.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - lbDragStartX;
        if (Math.abs(dx) > 40) { dx < 0 ? lbGoTo(current + 1) : lbGoTo(current - 1); }
      });
    }
  }

  // Teclado: Escape fecha, setas navegam
  document.addEventListener('keydown', function(e) {
    if (!lb || !lb.classList.contains('aberto')) return;
    if (e.key === 'Escape') lbClose();
    if (e.key === 'ArrowLeft') lbGoTo(current - 1);
    if (e.key === 'ArrowRight') lbGoTo(current + 1);
  });

  if (galeriaMain) {
    galeriaMain.addEventListener('click', function(e) {
      if (galeriaMain.dataset.justDragged === '1') {
        galeriaMain.dataset.justDragged = '0';
        return;
      }
      abrirLightbox();
    });
  }

  function onPointerDown(clientX) {
    dragging = true;
    dragLocked = false;
    dragStartX = clientX;
    dragDX = 0;
    if (galeriaTrack) galeriaTrack.classList.add('no-anim');
  }
  function onPointerMove(clientX) {
    if (!dragging) return;
    dragDX = clientX - dragStartX;
    if (Math.abs(dragDX) > 8) dragLocked = true;
    setTrackTransform(dragDX);
  }
  function onPointerUp() {
    if (!dragging) return;
    dragging = false;
    if (galeriaTrack) galeriaTrack.classList.remove('no-anim');
    if (Math.abs(dragDX) >= SWIPE_THRESHOLD) {
      if (dragDX < 0 && current < TOTAL - 1) {
        next();
        resetAutoplay();
      } else if (dragDX > 0 && current > 0) {
        prev();
        resetAutoplay();
      } else {
        setTrackTransform(0);
      }
      galeriaMain.dataset.justDragged = '1';
    } else {
      setTrackTransform(0);
      if (dragLocked) galeriaMain.dataset.justDragged = '1';
    }
    dragDX = 0;
    dragLocked = false;
  }

  if (galeriaMain) {
    galeriaMain.addEventListener('touchstart', function(e) {
      onPointerDown(e.touches[0].clientX);
    }, { passive: true });
    galeriaMain.addEventListener('touchmove', function(e) {
      onPointerMove(e.touches[0].clientX);
    }, { passive: true });
    galeriaMain.addEventListener('touchend', onPointerUp);
    galeriaMain.addEventListener('touchcancel', onPointerUp);

    galeriaMain.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      onPointerDown(e.clientX);
      e.preventDefault();
    });
    window.addEventListener('mousemove', function(e) {
      if (!dragging) return;
      onPointerMove(e.clientX);
    });
    window.addEventListener('mouseup', function() {
      if (dragging) onPointerUp();
    });
  }

  window.addEventListener('resize', function() {
    if (!galeriaTrack) return;
    galeriaTrack.classList.add('no-anim');
    setTrackTransform(0);
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { galeriaTrack.classList.remove('no-anim'); });
    });
  });

  if (TOTAL && galeriaTrack) {
    galeriaTrack.classList.add('no-anim');
    requestAnimationFrame(function() {
      setTrackTransform(0);
      requestAnimationFrame(function() {
        galeriaTrack.classList.remove('no-anim');
      });
    });
    updateThumbActive(0);
  }

  if (galeriaMain && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        inViewport = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        if (inViewport) {
          if (!initialized) {
            initialized = true;
            scheduleAutoplay(INITIAL_DELAY_MS);
          } else {
            scheduleAutoplay(INTERVAL_MS);
          }
        } else {
          clearAutoplay();
        }
      });
    }, { threshold: [0, 0.5, 1] });
    io.observe(galeriaMain);
  } else {
    inViewport = true;
    initialized = true;
    scheduleAutoplay(INITIAL_DELAY_MS);
  }

  document.addEventListener('visibilitychange', function() {
    if (document.hidden) clearAutoplay();
    else if (initialized) scheduleAutoplay(INTERVAL_MS);
  });

  (function() {
    var lb = document.getElementById('lightbox');
    if (!lb) return;
    var mo = new MutationObserver(function() {
      if (lb.classList.contains('aberto')) clearAutoplay();
      else if (initialized) scheduleAutoplay(INTERVAL_MS);
    });
    mo.observe(lb, { attributes: true, attributeFilter: ['class'] });
  })();

  // Variants
  function selecionarVariante(el) {
    document.querySelectorAll('.variacao-btn').forEach(function(b) { b.classList.remove('ativo'); b.classList.remove('erro'); });
    el.classList.add('ativo');
    var aviso = document.getElementById('variacao-aviso');
    if (aviso) aviso.classList.remove('visivel');
    var link = el.getAttribute('data-link');
    var vid = (link.match(/\/cart\/(\d+):/) || [])[1] || '';
    var idInput = document.getElementById('cod-variant-id');
    if (idInput && vid) idInput.value = vid;
    if (typeof window.syncVariant === 'function')
    window.syncVariant(vid);
  }
  window.selecionarVariante = selecionarVariante;

  document.querySelectorAll('.variacao-btn').forEach(function(btn) {
    btn.addEventListener('click', function() { selecionarVariante(btn); });
  });
  (function(){ var first = document.querySelector('.variacao-btn'); if (first) selecionarVariante(first); })();

  // CTA behavior
  document.querySelectorAll('#btn-comprar, #btn-cta-final, #btn-sticky').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var ativo = document.querySelector('.variacao-btn.ativo');
      if (!ativo) {
        e.preventDefault();
        document.querySelectorAll('.variacao-btn').forEach(function(b) { b.classList.add('erro'); });
        var aviso = document.getElementById('variacao-aviso');
        if (aviso) aviso.classList.add('visivel');
        var opcoes = document.getElementById('variacao-opcoes');
        if (opcoes) {
          var rect = opcoes.getBoundingClientRect();
          var top = rect.top + window.pageYOffset - (window.innerHeight/2 - rect.height/2);
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'add_to_cart',
          'variant_name': ativo.querySelector('.var-nome') ? ativo.querySelector('.var-nome').textContent.trim() : '',
          'variant_price': ativo.getAttribute('data-preco'),
          'variant_link': ativo.getAttribute('data-link')
        });
      }
    });
  });

  // Sticky CTA mobile
  var sticky = document.getElementById('sticky-comprar');
  function onScroll() {
    if (window.innerWidth > 600) {
      sticky.classList.remove('visivel');
      return;
    }
    if (window.scrollY > 600) sticky.classList.add('visivel');
    else sticky.classList.remove('visivel');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  // Barra de progresso — ease-out quártico, inicializa após load completo
  (function() {
    var bar = document.getElementById('scroll-progress-bar');
    if (!bar) return;
    var ticking = false;
    function update() {
      var scrollTop = window.scrollY || window.pageYOffset || 0;
      var sh = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight, document.body.offsetHeight);
      var ch = window.innerHeight;
      var max = (sh - ch) || 1;
      var t = Math.min(Math.max(scrollTop / max, 0), 1);
      var eased = 1 - Math.pow(1 - t, 4);
      bar.style.width = (eased * 100).toFixed(2) + '%';
      ticking = false;
    }
    function onScrollProgress() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScrollProgress, { passive: true });
    window.addEventListener('resize', onScrollProgress);
    // Aguarda load completo para scrollHeight refletir a página inteira
    if (document.readyState === 'complete') {
      update();
    } else {
      window.addEventListener('load', update);
    }
  })();

  // Geolocalização por IP
  (function() {
    fetch('https://api.ipinfo.io/lite/json?token=d92d196614f82f')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.city && data.region) {
          var ufMap = {
            'São Paulo':'SP','Rio de Janeiro':'RJ','Minas Gerais':'MG','Bahia':'BA',
            'Paraná':'PR','Rio Grande do Sul':'RS','Pernambuco':'PE','Ceará':'CE',
            'Pará':'PA','Santa Catarina':'SC','Maranhão':'MA','Goiás':'GO',
            'Amazonas':'AM','Espírito Santo':'ES','Paraíba':'PB','Mato Grosso':'MT',
            'Rio Grande do Norte':'RN','Alagoas':'AL','Piauí':'PI','Distrito Federal':'DF',
            'Mato Grosso do Sul':'MS','Sergipe':'SE','Rondônia':'RO','Tocantins':'TO',
            'Acre':'AC','Amapá':'AP','Roraima':'RR'
          };
          var uf = ufMap[data.region] || data.region;
          var el = document.getElementById('cidade-visitante');
          if (el) el.textContent = data.city + ', ' + data.region;
        }
      })
      .catch(function() {});
  })();

  // Social proof toasts
  var toastData = [
    { name: 'Patrícia M.',    produto: 'Aceite de Orégano Biovera' },
    { name: 'Rodrigo S.',     produto: 'Aceite de Orégano Biovera' },
    { name: 'Camila F.',      produto: 'Aceite de Orégano Biovera' },
    { name: 'Juliana R.',     produto: 'Aceite de Orégano Biovera' },
    { name: 'Thiago A.',      produto: 'Aceite de Orégano Biovera' },
    { name: 'Fernanda L.',    produto: 'Aceite de Orégano Biovera' },
    { name: 'Marcos V.',      produto: 'Aceite de Orégano Biovera' },
    { name: 'Beatriz C.',     produto: 'Aceite de Orégano Biovera' },
    { name: 'Lucas M.',       produto: 'Aceite de Orégano Biovera' },
    { name: 'Amanda P.',      produto: 'Aceite de Orégano Biovera' },
    { name: 'Carlos H.',      produto: 'Aceite de Orégano Biovera' },
    { name: 'Rafaela G.',     produto: 'Aceite de Orégano Biovera' }
  ];
  var toastIndex = 0;
  function showToast(name, produto) {
    var t = document.createElement('div');
    t.className = 'social-toast';
    t.innerHTML =
      '<div class="icon">✓</div>' +
      '<div class="body">' +
        '<div class="title">' + name + '</div>' +
        '<div class="sub">compró ' + produto + '</div>' +
        '<div class="live">ahora</div>' +
      '</div>';
    document.body.appendChild(t);
    requestAnimationFrame(function() { t.classList.add('shown'); });
    setTimeout(function() {
      t.classList.add('hiding');
      setTimeout(function() { t.remove(); }, 220);
    }, 5000);
  }
  function cycleToasts() {
    var d = toastData[toastIndex % toastData.length];
    showToast(d.name, d.produto);
    toastIndex++;
    setTimeout(cycleToasts, 20000);
  }
  setTimeout(cycleToasts, 8000);

  // Animated counters
  (function() {
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function formatBR(value, decimals) {
      var fixed = value.toFixed(decimals);
      return decimals > 0 ? fixed.replace('.', ',') : fixed;
    }

    function animate(el) {
      var raw = el.getAttribute('data-counter');
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      var target = parseFloat(raw.replace(',', '.'));
      var decimals = (raw.indexOf(',') !== -1) ? (raw.length - raw.indexOf(',') - 1) : 0;

      if (reduce || isNaN(target)) {
        el.textContent = prefix + formatBR(target, decimals) + suffix;
        return;
      }

      var duration = 1500;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var elapsed = ts - start;
        var t = Math.min(elapsed / duration, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        var current = target * eased;
        el.textContent = prefix + formatBR(current, decimals) + suffix;
        if (t < 1) requestAnimationFrame(step);
        else el.textContent = prefix + formatBR(target, decimals) + suffix;
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      counters.forEach(animate);
      return;
    }

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !entry.target.dataset.counted) {
          entry.target.dataset.counted = '1';
          var raw = entry.target.getAttribute('data-counter');
          var prefix = entry.target.getAttribute('data-prefix') || '';
          var suffix = entry.target.getAttribute('data-suffix') || '';
          var decimals = (raw.indexOf(',') !== -1) ? (raw.length - raw.indexOf(',') - 1) : 0;
          entry.target.textContent = prefix + formatBR(0, decimals) + suffix;
          animate(entry.target);
          var ring = entry.target.closest && entry.target.closest('.stat-ring');
          if (ring) {
            var pct = parseFloat(ring.getAttribute('data-percent')) || 0;
            var fill = ring.querySelector('.ring-fill');
            if (fill) {
              var circumference = 295.31;
              var offset = circumference * (1 - Math.min(Math.max(pct, 0), 100) / 100);
              if (reduce) { fill.style.transition = 'none'; }
              requestAnimationFrame(function() { fill.style.strokeDashoffset = offset; });
            }
          }
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(el) { io.observe(el); });
  })();

  // Fade-in-up on scroll
  (function() {
    (function() {
      var hlEls = document.querySelectorAll('.highlight-num');
      if (!hlEls.length) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { hlEls.forEach(function(e){ e.classList.add('is-visible'); }); return; }
      if (!('IntersectionObserver' in window)) { hlEls.forEach(function(e){ e.classList.add('is-visible'); }); return; }
      var hio = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            hio.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });
      hlEls.forEach(function(e){ hio.observe(e); });
    })();

    var selectors = [
      '.sintoma-card',
      '.parasita-item',
      '.ingrediente-card',
      '.benefit-card',
      '.ugs-card',
      '.biofilme-destaque',
      '.produto-destaque'
    ];
    var els = document.querySelectorAll(selectors.join(','));
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    els.forEach(function(el) { el.classList.add('fade-in-up'); });

    var staggerSelectors = ['.sintomas-grid', '.parasita-lista', '.ingredientes-grid', '.benefits-grid'];
    staggerSelectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(grid) {
        var children = grid.children;
        for (var i = 0; i < children.length; i++) {
          var c = children[i];
          if (!c.classList.contains('fade-in-up')) c.classList.add('fade-in-up');
          c.style.transitionDelay = (i * 100) + 'ms';
        }
      });
    });

    if (!('IntersectionObserver' in window)) {
      els.forEach(function(el) { el.classList.add('is-visible'); });
      document.querySelectorAll('.fade-in-up').forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -150px 0px' });

    document.querySelectorAll('.fade-in-up:not(.review-card)').forEach(function(el) { io.observe(el); });

    var reviews = document.querySelectorAll('.review-card');
    if (reviews.length) {
      reviews.forEach(function(r) { r.classList.add('fade-in-up', 'fade-in-up--review'); });
      var lastRevealAt = 0;
      var rio = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var now = performance.now();
            var delay = 0;
            if (now - lastRevealAt < 200) {
              delay = 80;
            }
            entry.target.style.transitionDelay = delay + 'ms';
            setTimeout(function() {
              entry.target.classList.add('is-visible');
            }, delay);
            lastRevealAt = now + delay;
            rio.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -100px 0px' });
      reviews.forEach(function(r) { rio.observe(r); });
    }
  })();

  // Skeleton loading
  (function() {
    var selectors = [
      '#galeria-track img',
      '#thumbs img',
      '.step-media img',
      '.review-avatar',
      '.review-foto img'
    ];
    var imgs = document.querySelectorAll(selectors.join(','));
    imgs.forEach(function(img) {
      if (!img || img.tagName !== 'IMG') return;
      var keepInline = img.classList.contains('review-avatar') || img.classList.contains('var-img');
      var target;
      if (keepInline) {
        img.classList.add('skel-wrap');
        var wrap = document.createElement('span');
        wrap.className = 'skel-wrap';
        if (img.classList.contains('review-avatar')) wrap.classList.add('review-avatar');
        if (img.classList.contains('var-img')) wrap.classList.add('var-img');
        img.classList.remove('skel-wrap');
        img.parentNode.insertBefore(wrap, img);
        wrap.appendChild(img);
        target = wrap;
      } else {
        var w = document.createElement('span');
        w.className = 'skel-wrap';
        w.style.display = 'block';
        w.style.width = '100%';
        w.style.height = '100%';
        img.parentNode.insertBefore(w, img);
        w.appendChild(img);
        target = w;
      }

      function onLoad() { target.classList.add('is-loaded'); }
      if (img.complete && img.naturalWidth > 0) {
        target.classList.add('is-loaded');
      } else {
        img.addEventListener('load', onLoad, { once: true });
        img.addEventListener('error', onLoad, { once: true });
      }
    });
  })();
